import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { StyledColumnProps } from '../Column';

export const StyledColumn = styled('div')<StyledColumnProps>(() => {
  return {
    display: 'flex',
    flexDirection: 'Column',
  };
}, getAllStyledProps);
